import { Injectable } from "@nestjs/common";
import { TeamDto } from "./dtos/teams.dto";
import { TeamsEntity } from "./entities/teams.entity";

@Injectable()
export class TeamsAdapter{

    public convertDtoToEntity(dto:TeamDto, isUpdate:boolean=false):TeamsEntity{
        const entity = new TeamsEntity();
        entity.id = dto.id;
        entity.shiftCode = dto.shiftCode;
        entity.updatedUser=dto.updatedUser;
        entity.updatedAt=dto.updatedAt;
        entity.createdUser=dto.createdUser;
        entity.isActive = dto.isActive === undefined ? true : dto.isActive;
        if(isUpdate){

            entity.isActive = true;
             }
        return entity;
    }

    public convertEntityToDto(entity:TeamsEntity):TeamDto{
        const dto = new TeamDto();
        dto.id = entity.id;
        dto.shiftCode = entity.shiftCode;
        dto.isActive = entity.isActive;
        dto.createdAt = entity.createdAt;
        dto.createdUser = entity.createdUser;
        dto.updatedAt = entity.updatedAt;
        dto.updatedUser = entity.updatedUser;
        dto.versionFlag = entity.versionFlag;
        return dto;

    }
}

